const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};
export { THEMES }